import React, { useState } from "react";
import { Stack, TextField, Typography, IconButton, Tooltip, Box, Chip } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { getFileIcon, getFileExtension, formatFileSize, MAX_LABEL_LENGTH } from "../../../utils/formHelper";
import "./Documentrow.scss";

const DocumentRow = ({ file, onLabelChange, onView, onDownload, onDelete, disabled = false }) => {
  const { Icon, colorClass } = getFileIcon(file.name);
  const [isEditingLabel, setIsEditingLabel] = useState(false);

  const handleTagClick = () => {
    if (!disabled) setIsEditingLabel(true);
  };

  const handleLabelBlur = () => {
    setIsEditingLabel(false);
  };

  const handleLabelKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setIsEditingLabel(false);
    }
  };

  return (
    <Stack direction="row" alignItems="center" spacing={1.5} className="file-row_container">
      <Box className={`file-row_icon ${colorClass}`}>
        <Icon fontSize="small" />
      </Box>

      <Stack className="file-row_info" spacing={0.25}>
        <Stack direction="row" alignItems="center" spacing={1} className="file-row_title-row">
          <Typography variant="body2" className="file-row_name" noWrap>
            {file.name}
          </Typography>

          {isEditingLabel ? (
            <TextField
              variant="standard"
              size="small"
              autoFocus
              value={file.label}
              placeholder="Add label"
              onChange={(event) => onLabelChange(file.id, event.target.value)}
              onBlur={handleLabelBlur}
              onKeyDown={handleLabelKeyDown}
              className="file-row_label-input"
              inputProps={{ maxLength: MAX_LABEL_LENGTH }}
            />
          ) : (
            <Chip
              size="small"
              variant={file.label ? "filled" : "outlined"}
              icon={<LocalOfferOutlinedIcon fontSize="small" />}
              label={file.label || "Add label"}
              onClick={handleTagClick}
              disabled={disabled}
              className={`file-row_label-tag ${file.label ? "file-row_label-tag-filled" : "file-row_label-tag-empty"}`}
            />
          )}
        </Stack>

        <Typography variant="caption" color="text.secondary" className="file-row_meta">
          {[getFileExtension(file.name), formatFileSize(file.size), file.uploadedDate, file.uploadedBy].filter(Boolean).join(" • ")}
        </Typography>
      </Stack>

      <Stack direction="row" spacing={0.5} className="file-row_actions">
        <Tooltip title="View file" placement="top">
          <IconButton size="small" onClick={() => onView(file)} aria-label="View file">
            <VisibilityOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        <Tooltip title="Download file" placement="top">
          <IconButton size="small" onClick={() => onDownload(file)} aria-label="Download file">
            <DownloadOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        {!disabled && (
          <Tooltip title="Remove file" placement="top">
            <IconButton size="small" color="error" onClick={() => onDelete(file.id)} aria-label="Remove file">
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
    </Stack>
  );
};

export default DocumentRow;